
import React from 'react';
import { Tabs, Tab, Container } from 'react-bootstrap';
import EmiCalculator from './EmiCalculator';
import GstCalculator from './GstCalculator';
import ProfitMarginCalculator from './ProfitMarginCalculator';
import IncomeTaxCalculator from './IncomeTaxCalculator';
import SipCalculator from './SipCalculator';
import CapitalGainsCalculator from './CapitalGainsCalculator';
import RetirementNpsCalculator from './RetirementNpsCalculator';
import HraCalculator from './HraCalculator';
import PpfCalculator from './PpfCalculator';
import InterestCalculator from './InterestCalculator';
import TdsTcsCalculator from './TdsTcsCalculator';
import { User } from 'firebase/auth';

interface CalculatorsProps {
  currentUser: User | null;
}

const Calculators: React.FC<CalculatorsProps> = ({ currentUser }) => {
  return (
    <Container className="py-5">
      <h2 className="text-center mb-4">Business Calculators</h2>
      <Tabs defaultActiveKey="emi" id="calculator-tabs" className="mb-3">
        <Tab eventKey="emi" title="Loan/EMI Calculator">
          <EmiCalculator currentUser={currentUser} />
        </Tab>
        <Tab eventKey="gst" title="GST Calculator">
          <GstCalculator currentUser={currentUser} />
        </Tab>
        <Tab eventKey="profit" title="Profit Margin Calculator">
          <ProfitMarginCalculator currentUser={currentUser} />
        </Tab>
        <Tab eventKey="incomeTax" title="Income Tax Calculator">
          <IncomeTaxCalculator currentUser={currentUser} />
        </Tab>
        <Tab eventKey="sip" title="SIP Calculator">
          <SipCalculator currentUser={currentUser} />
        </Tab>
        <Tab eventKey="capitalGains" title="Capital Gains Calculator">
          <CapitalGainsCalculator currentUser={currentUser} />
        </Tab>
        <Tab eventKey="nps" title="NPS Calculator">
          <RetirementNpsCalculator currentUser={currentUser} />
        </Tab>
        <Tab eventKey="hra" title="HRA Calculator">
          <HraCalculator currentUser={currentUser} />
        </Tab>
        <Tab eventKey="ppf" title="PPF Calculator">
          <PpfCalculator currentUser={currentUser} />
        </Tab>
        <Tab eventKey="interest" title="Interest Calculator">
          <InterestCalculator />
        </Tab>
        <Tab eventKey="tds" title="TDS/TCS Calculator">
          <TdsTcsCalculator />
        </Tab>
      </Tabs>
    </Container>
  );
};

export default Calculators;
